import * as React from "react";
import { Clock, MapPin, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
export default function VisitTheStable() {
  return <section data-section-id="132144" id="our-detailing-sanctuary" className="relative flex min-h-[600px] w-full items-center justify-center py-24 md:py-32 dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1593773/img/grayscale_map_bg.png')] bg-cover bg-center bg-no-repeat grayscale opacity-20" />
      
      {}
      <div className="absolute inset-0 z-0 bg-background/80 backdrop-blur-[2px]" />

      {}
      <Card className="relative z-10 mx-4 w-full max-w-md border border-white/10 bg-secondary/80 text-foreground shadow-2xl backdrop-blur-xl rounded-sm">
        <CardHeader className="pb-4 text-center">
          <CardTitle className="font-serif text-3xl tracking-widest uppercase text-foreground">
            The Sanctuary
          </CardTitle>
          <CardDescription className="font-mono text-primary text-xs mt-2 uppercase tracking-tighter">Bathers Auto Detailing</CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-8 pt-4">
          {}
          <div className="flex items-start gap-4">
            <div className="rounded-sm bg-primary/10 p-2 shrink-0 border border-primary/20">
              <MapPin className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h4 className="font-sans font-bold text-sm uppercase tracking-wider text-foreground mb-1">running Mobile service</h4>
              <p className="font-sans text-muted-foreground text-sm leading-relaxed"><br /></p>
            </div>
          </div>

          {}
          <div className="flex items-start gap-4">
            <div className="rounded-sm bg-primary/10 p-2 shrink-0 border border-primary/20">
              <Clock className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h4 className="font-sans font-bold text-sm uppercase tracking-wider text-foreground mb-1">Operation Hours</h4>
              <p className="font-mono text-muted-foreground text-xs leading-relaxed">BY APPOINTMENT</p>
            </div>
          </div>
        </CardContent>

        <CardFooter className="flex justify-center pb-8 pt-4">
          <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_15px_rgba(0,255,255,0.3)] transition-all duration-300 rounded-sm font-bold tracking-widest uppercase">
            
          </Button>
        </CardFooter>
      </Card>
    </section>;
}